module.exports = __webpack_public_path__ + "img/IMG_20191130_010441.cf48be96.jpg";